export default [{
  path: '/myDigitalListPage',
  name: 'myDigitalListPage',
  component: () => import('@/views/myDiigitalList/index'),
}]
